import { mergeAttributes, Node } from '@tiptap/core'

export const StepperDescription = Node.create({
  name: 'stepperDescription',

  content: 'paragraph+',
  //content: 'block+',

  isolating: true,

  parseHTML() {
    return [
      {
        tag: `td[data-type="${this.name}"]`,
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'td',
      mergeAttributes(
        HTMLAttributes,
        {
          'data-type': this.name,
          width: '50%',
          class: 'stepper-description'
        }
      ),
      0
    ]
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        if (!editor.isActive('stepperDescription')) return false
        const pos = editor.state.selection.$from.end()

        return editor.chain().focus(pos).insertContentAt(pos, { type: 'paragraph' }).run()
      },
    }
  },
})

export default StepperDescription
